import React, { useEffect, useState } from 'react';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';

import { connect } from 'react-redux';
import * as common from '../../../common/__redux/commonRedux';
import PropTypes from 'prop-types';
import axios from 'axios';

import caretRightFilter from '../../../../../assets/icons/ic_caret_right_filter.svg';
import icRemoveFilter from '../../../../../assets/icons/ic_remove_filter.svg';
import icExperience from '../../../../../assets/icons/ic_experience.svg';
import {
	getProviders
} from '../provider_experiences/networking';
import SelectFilterProviders from './SelectFilterProviders';
import SelectFilterGttd from './SelectFilterGttd';

const FilterDialog = (props) => {
	const dictionary = useDictionary();

	const [showDialog, setDialogVisibility] = useState(false);
	const [enableScheduling, setEnableScheduling] = useState(false);

	const [showBoxFilter, setShowBoxFilter] = useState(true);
	
	const [showProviderSelectbox, setShowProviderSelectbox] = useState(false);
	const [providers, setProviders] = useState([]);

	const [providerNameSelecteds, setProviderNameSelecteds] = useState([]);
	const [providerCheckeds, setProviderCheckeds] = useState([]);
	const [providerStatuses, setProviderStatuses] = useState({});
	const [showGttdSelectbox, setShowGttdSelectbox] = useState(false);
	const [gttdSelectedItems, setGttdSelectedItems] = useState([]);
	const [gttdCheckItems, setGttdCheckItems] = useState([]);

	const onFinishClicked = () => {
		props.setCurrentPage(0);
		props.onScheduleSet();
		onCancelClicked();
	};
	
	useEffect(() => {
		setTimeout(() => {
			setDialogVisibility(true);
		}, 50);

		getAllProvidersAsync();
		getProviderSelected();
		getGttdSelected();
		if (props.filterCount > 0) {
			setEnableScheduling(true);
		}
	}, []);

	const onCancelClicked = () => {
		dismissDialog();
	};

	const dismissDialog = () => {
		setDialogVisibility(false);
		setTimeout(() => {
			props.setShowFilterDialog(false);
		}, 600);
	};

	const getAllProvidersAsync = async () => {
		try {
			const providerData  = await getProviders();
			if (providerData.data.data.length > 0) {
				setProviders(providerData.data.data);
				let providerObjs = {};
				for (const provider of providerData.data.data) {
					const itemProvider = {
						id: provider.id,
						text:  provider.brand_name ? provider.brand_name : provider.email,
						class: provider.id
					};
					providerObjs[provider.id] = itemProvider;
				}
				localStorage.setItem(`${props.storageName}_filter_provider_list`, JSON.stringify(providerObjs));
				setProviderStatuses(providerObjs);
			}  else {
				// props.onNoResults();
			}
		} catch (error) {
			//
		}
	};

	const getProviderSelected = () => {
		const providerIds = JSON.parse(localStorage.getItem(`${props.storageName}_filter_provider`)) || [];
		let expStatuses = providerStatuses;
		if (Object.keys(providerStatuses).length === 0) {
			expStatuses = JSON.parse(localStorage.getItem(`${props.storageName}_filter_provider_list`)) || {};
			setProviderStatuses(expStatuses);
		}
		let providerSelecteds = [];
		Object.keys(expStatuses).forEach((providerStatus) => {
			if (providerIds.includes(providerStatus)) {
				providerSelecteds.push(expStatuses[providerStatus]);
			}
		});

		setProviderNameSelecteds(providerSelecteds);

		let providerCheckedElms = {};
		Object.keys(expStatuses).forEach((providerStatus) => {
			providerCheckedElms[providerStatus] = providerIds.includes(providerStatus);
		});

		setProviderCheckeds(providerCheckedElms);
	}

	const getGttdSelected = () => {
		const gttdIds = JSON.parse(localStorage.getItem(`${props.storageName}_gttd_status`)) || [];
		let gttdSelecteds = [];
		Object.keys(props.gttdStaticsValues).forEach((status) => {
			if (gttdIds.includes(status)) {
				gttdSelecteds.push({
					value: status,
					text: props.gttdStaticsValues[status].text
				});
			}
		});

		setGttdSelectedItems(gttdSelecteds);


		let gttdCheckedElms = {};
		Object.keys(props.gttdStaticsValues).forEach((status) => {
			gttdCheckedElms[status] = gttdIds.includes(status);
		});

		setGttdCheckItems(gttdCheckedElms);
	};

	const showStatusBox = () => {
		if (showGttdSelectbox) {
			setShowGttdSelectbox(false);
			setShowBoxFilter(true);
		} else {
			setShowGttdSelectbox(true);
			setShowBoxFilter(false);
		}
	};
	const onFilterStatusSelected = (statusParams) => {
		props.setFilterGttdParams(statusParams);
		localStorage.setItem(`${props.storageName}_gttd_status`, JSON.stringify(statusParams));
		props.onGttdValuesChanged();
		getGttdSelected();
	};

	const showProviderBox = () => {
		if (showProviderSelectbox) {
			setShowProviderSelectbox(false);
			setShowBoxFilter(true);
		} else {
			setShowProviderSelectbox(true);
			setShowBoxFilter(false);
		}
	}

	const onFilterProviderSelected = (statusParams) => {
		props.setFilterProviderParams(statusParams);
		localStorage.setItem(`${props.storageName}_filter_provider`, JSON.stringify(statusParams));
		props.onProviderValuesChanged();
		getProviderSelected();
	};
	
	const removeExperienceFilter = (experienceId) => {
		let providerIds = JSON.parse(localStorage.getItem(`${props.storageName}_filter_provider`)) || [];
		if (providerIds.includes(experienceId)) { 
			for( var i = 0; i < providerIds.length; i++) { 
				if ( providerIds[i] === experienceId) { 
					providerIds.splice(i, 1); 
				}
			}
		}

		if (providerIds.length > 0) {
			localStorage.setItem(`${props.storageName}_filter_provider`, JSON.stringify(providerIds));
		} else {
			localStorage.removeItem(`${props.storageName}_filter_provider`);
		}

		props.onProviderValuesChanged();
		props.setFilterProviderParams(providerIds);
		getProviderSelected();
		setEnableScheduling(true);
	}
	const removeGttdFilter = (gttdid) => {
		let gttdIds = JSON.parse(localStorage.getItem(`${props.storageName}_gttd_status`)) || [];
		if (gttdIds.includes(gttdid)) { 
			for( var i = 0; i < gttdIds.length; i++) { 
				if ( gttdIds[i] === gttdid) { 
					gttdIds.splice(i, 1); 
				}
			}
		}

		if (gttdIds.length > 0) {
			localStorage.setItem(`${props.storageName}_gttd_status`, JSON.stringify(gttdIds));
		} else {
			localStorage.removeItem(`${props.storageName}_gttd_status`);
		}
		props.onGttdValuesChanged();
		props.setFilterGttdParams(gttdIds);
		getGttdSelected();
		setEnableScheduling(true);
	}

	const handleResetAll = () => {
		localStorage.removeItem(`${props.storageName}_filter_provider`);
		localStorage.removeItem(`${props.storageName}_gttd_status`);
		props.onProviderValuesChanged();
		props.onGttdValuesChanged();
		getProviderSelected();
		getGttdSelected();
		setShowProviderSelectbox(false);
		setShowBoxFilter(true);
		setEnableScheduling(false);
		props.setFilterProviderParams([]);
		setShowGttdSelectbox(false);
		props.setFilterGttdParams([]);
		props.onScheduleSet(true);
	}

	return (
		<div
			onClick={() => onCancelClicked()}
			className="dialog-wrapper"
			style={{ background: 'transparent', position: 'fixed', zIndex: '11' }}
			data-testid="schedule-dialog-wrapper"
		>
			<div
				onClick={(e) => e.stopPropagation()}
				className={
					showDialog
						? 'experience-category-tags-wrapper experience-category-tags-wrapper-visible'
						: 'experience-category-tags-wrapper'
				}
				data-testid="schedule-dialog"
			>
				<div className="schedule-dialog-content-wrapper thin-scrollbar">
					<div
						className="dialog-close-button"
						style={{ right: '24px', top: '21px' }}
						onClick={onCancelClicked}
						data-testid="schedule-dialog-close-button"
					/>
					
					<div className="schedule-dialog-content-container schedule-dialog-content-container-pa-0">
						<div className="schedule-dialog-content-container-content border-bottom">
							<h2 style={{ whiteSpace: 'pre-line', fontSize: '16px', lineHeight: '24px', fontWeight: 500 }}>
								Filters
							</h2>
						</div>
						
						<div className="schedule-dialog-content-container-content">
							{showBoxFilter ? (
								<>
									<div className="box-filter-list">
										<div className="group-filter">
											<div className="group-filter-icon-label">
												<img className="group-filter-icon" src={icExperience} />
												<span onClick={showProviderBox} className="group-filter-label">{dictionary.providers}</span>
											</div>
											<img onClick={showProviderBox} className="icon-to-select" src={caretRightFilter} />
										</div>
										
										<div className="group-filter-selected-status">
											{providerNameSelecteds.map((provider) => (
												<div className="filter-selected-item" key={provider.id}>
													<span>{provider.text}</span>
													<img onClick={() => removeExperienceFilter(provider.id)} src={icRemoveFilter} />
												</div>
											))}
										</div>
									</div>
									<div className="box-filter-list">
										<div className="group-filter">
											<div className="group-filter-icon-label">
												<span onClick={showStatusBox} className="group-filter-label">{dictionary.goolge_thinks_to_do}</span>
											</div>
											<img onClick={showStatusBox} className="icon-to-select" src={caretRightFilter} />
										</div>
										
										<div className="group-filter-selected-status">
											{gttdSelectedItems.map((gttdItem) => (
												<div className="filter-selected-item" key={gttdItem.value}>
													<span>{gttdItem.text}</span>
													<img onClick={() => removeGttdFilter(gttdItem.value)} src={icRemoveFilter} />
												</div>
											))}
										</div>
									</div>
								</>
							): null}
							
							{showProviderSelectbox ? (
								<SelectFilterProviders
									setShowBoxFilter={setShowBoxFilter} 
									setShowProviderSelectbox={setShowProviderSelectbox} 
									onFilterProviderSelected={onFilterProviderSelected}
									providerCheckeds={providerCheckeds}
									setEnableScheduling={setEnableScheduling}
									filterCount={props.filterCount}
									providers={providers}
								/>
							) : null}
							{showGttdSelectbox ? (
								<SelectFilterGttd
									setShowBoxFilter={setShowBoxFilter}
									setShowGttdSelectbox={setShowGttdSelectbox}
									onFilterStatusSelected={onFilterStatusSelected}
									statusCheckeds={gttdCheckItems}
									setEnableScheduling={setEnableScheduling}
									filterCount={props.filterCount}
									gttdStaticsValues={props.gttdStaticsValues}
								/>
							) : null}
						</div>
					</div>
				</div>

				<div className="filter-dialog-button-container">
					<button
						onClick={() => handleResetAll()}
						className="schedule-dialog-reset-button"
						data-testid="schedule-dialog-reset-button"
					>
						Reset
					</button>
					<button
						disabled={!enableScheduling}
						onClick={() => onFinishClicked()}
						className="button filter-dialog-apply-button"
						data-testid="filter-dialog-apply-button"
					>
						Apply
					</button>
				</div>
			</div>
		</div>
	);
};

FilterDialog.propTypes = {
	onProviderValuesChanged: PropTypes.func,
	setShowFilterDialog: PropTypes.func,
	countAllFilter: PropTypes.func,
	filterCount: PropTypes.number,
	setFilterProviderParams: PropTypes.func,
	onScheduleSet: PropTypes.func,
	setFilterGttdParams: PropTypes.func,
	onGttdValuesChanged: PropTypes.func,
	gttdStaticsValues: PropTypes.any,
	setCurrentPage: PropTypes.func,
	storageName: PropTypes.string
};

export default connect(common.states, common.actions)(FilterDialog);
